import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { ClaimCounter } from '@core/referrals-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{
  counters: ClaimCounter[];
}>()('ReferralsClaimCounters');

export {
  actions as ReferralsClaimCounterActions,
  reducer as ReferralsClaimCounterReducer,
  selectors as ReferralsClaimCounterSelectors,
  namespace as ReferralsClaimCounterNamespace,
};
